module.exports = __webpack_public_path__ + "img/cp32_03.492ff746.jpg";